import { LBAlertCircleIcon } from '@linearb/buzz';

const Info = ({ sensorName, scopesValidations }) => {
  const { isValid, isError, isLoading } = scopesValidations;

  if (isLoading) return null;
  if (isError) return <>Ooops... Something went wrong.</>;
  if (!isValid)
    return (
      <div className='flex items-start gap-1'>
        <div>
          <LBAlertCircleIcon className='text-destructive text-lg' />
        </div>
        <div className='leading-tight'>
          Make sure you have the required permissions, or connect to{' '}
          {sensorName} with a different account before attempting to
          reauthorize.
        </div>
      </div>
    );
};

const ScopesValidationsInfo = ({ scopesValidations, sensorName }) => {
  return (
    <div className='flex flex-col'>
      <div className='text-sm'>
        <Info scopesValidations={scopesValidations} sensorName={sensorName} />
      </div>
    </div>
  );
};

export default ScopesValidationsInfo;
